import { Asset } from '@tassat/fred-definitions';
import { AssetTypes } from '@tassat/ui-definitions';
import { Decimal } from 'decimal.js';

import { formatAsAssetNoSign } from '../formatAsAsset';
import { convertToNumberString } from '../stringHelpers/helpers';

export const stripPrefix = (value, prefix) => {
    return value.toString()
        .replace(prefix, '');
};

export const assetConversionHelper = (value: string, Product, asset: Asset) => {
    // The value to be converted from, the product of conversion, and the asset type being converted TO
    // Also remove prefixes from the currency input (i.e. "$1.12" -> "1.12" or "TFND 123.2213" -> "123.2213")
    const numberValue = new Decimal(convertToNumberString(value));
    const price = new Decimal(Product);

    if (asset.Type === AssetTypes.ASSET) {
        const conversion = numberValue.div(price);

        return formatAsAssetNoSign(conversion.toString(), asset, true);
    }

    if (asset.Type === AssetTypes.CURRENCY) {
        const conversion = numberValue.mul(price);

        return formatAsAssetNoSign(conversion.toString(), asset);
    }
};